import {
  ARTICLE_LIST_FETCH,
  ARTICLE_LIST_SUCCESS,
  ARTICLE_LIST_FAILURE
} from './actionTypes';

//import { ADD_ARTICLE_TO_THE_LIST } from '../ServiceForm/actionTypes';

const initialState = {
  isLoaded: false,
  articles: [],
  error: []
};

export const articlesReducer = (state = initialState, action) => {
  switch (action.type) {
    case ARTICLE_LIST_FETCH:
      return { ...state, isLoaded: false };
    case ARTICLE_LIST_SUCCESS:
      return { ...state, isLoaded: true, articles: action.payload };
    /*     case ADD_ARTICLE_TO_THE_LIST:
      return {
        ...state,
        isLoaded: true,
        articles: [...state.articles, action.payload]
      }; */
    case ARTICLE_LIST_FAILURE:
      return {
        ...state,
        error: action.payload
      };
    default:
      return state;
  }
};

export const isLoaded = state => state.articleList.isLoaded;
export const getArticles = state => state.articleList.articles;
export const getError = state => state.articleList.error;



// WEBPACK FOOTER //
// ./src/modules/ArticleList/reducer.js